<template>
  <div
    class="c-app flex-row align-items-center"
    style="min-height: 85vh !important"
  >
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="6" lg="6">
          <img src="/newragelogo.png" style="width: 60%; height: 92%" />
        </CCol>
        <CCol md="6" lg="4">
          <!-- <CCardGroup> -->
          <CCard class="p-4 vertical-center">
            <CCardBody>
              <CForm>
                <h1>Login</h1>
                <!-- <p class="text-muted"  style="color:red !important"></p> -->
                <CAlert
                  color="danger"
                  closeButton
                  :show.sync="alert1"
                  v-if="admin"
                  >Invalid user</CAlert
                >
                <CRow v-if="errorMessage">
                  <CCol col="12">
                    <CAlert color="danger" closeButton :show.sync="alert1">{{
                      errorMessage
                    }}</CAlert>
                  </CCol>
                </CRow>
                <!-- <p class="text-muted">Sign In to your account</p> -->

                <CInput
                  placeholder="Username"
                  autocomplete="username email"
                  v-model="email"
                >
                  <template #prepend-content>
                    <CIcon name="cil-user" />
                  </template>
                </CInput>
                <CInput
                  placeholder="Password"
                  type="password"
                  autocomplete="curent-password"
                  v-model="password"
                >
                  <template #prepend-content>
                    <CIcon name="cil-lock-locked" />
                  </template>
                </CInput>
                <CRow>
                  <CCol col="6" class="text-left">
                    <CButton color="primary" v-if="btnload">
                      <i class="fa fa-refresh fa-spin"></i>Loading
                    </CButton>

                    <CButton
                      color="primary"
                      class="px-4"
                      @click="login"
                      v-if="lgnbtn"
                      >Login</CButton
                    >
                  </CCol>
                  <!-- <CCol col="6" class="text-right">
                    <CButton color="link" class="px-0" @click="forgotpassword">Forgot password?</CButton>
                  </CCol> -->
                </CRow>
                <CRow>
                  <!-- <CCol col="12" class="text-center" style="margin-top:20px">
                    <span>Don't have an account?</span>
                    <router-link to="RegisterPage">
                      <CButton color="link" class="d-lg register-now" @click="sign">Register now!</CButton>
                    </router-link>
                  </CCol> -->
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
          <!-- <CCard
              color="primary"
              text-color="white"
              class="text-center py-5 d-md-down-none"
              body-wrapper
            >
              <CCardBody>
                <h2>Sign up</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                <router-link to="register"><CButton
                  color="light"
                  variant="outline"
                  size="lg"
                >
                  Register Now!
                </CButton></router-link>
              </CCardBody>
          </CCard>-->
          <!-- </CCardGroup> -->
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
// import firebase from "firebase";
// import utils from "@/services/utils.js";

import { APIService } from "@/apiservice.js";
import firebase from "firebase";
const db = firebase.firestore();
export default {
  name: "Login",
  data() {
    return {
      admin: false,
      Spinner: false,
      email: "",
      password: "",
      user: {
        email: "",
        password: "",
        submitted: false,
        msg: "fdr",
      },
      errMsg: null,
      alert1: true,
      errorMessage: null,
      backup: "start",
      btnload: false,
      lgnbtn: true,
    };
  },
  watch: {
    email() {
      this.admin = false;
    },
  },
  methods: {
    login() {
      let self = this;
      this.errMsg = null;
      const { dispatch } = self.$store;
      this.err = null;
      // if (this.email == "admin@gmail.com") {
      let log = firebase.auth();
      log
        .signInWithEmailAndPassword(this.email, this.password)
        .then((res) => {
          db.collection("users")
            .where("email", "==", this.email)
            .get()
            .then((snapshot) => {
              snapshot.forEach((doc) => {
                let userData = doc.data();
                userData.userRole =
                  doc.data().userRole != undefined
                    ? doc.data().userRole
                    : "user";

                if (userData.userRole != undefined) {
                  if (
                    userData.userRole == "admin" ||
                    userData.userRole == "support" ||
                    userData.userRole == "marketing"
                  ) {
                    localStorage.setItem("data", JSON.stringify(userData));
                    if (
                      JSON.parse(
                        localStorage.getItem("data").length !== undefined
                      )
                    ) {
                      this.btnload = true;
                      this.lgnbtn = false;
                      // this.$router.push({ path: "/dashboard" });

                      this.$router.push({ path: "/userList" });
                    } else {
                      this.$router.push({ name: "LoginPage" });
                    }
                  }else if(userData.userRole == "user"){
                    console.log("user count");
                    self.errorMessage =
                      "User accounts are not allowed, Try Admin account to login.";
                    const auth = firebase.auth();
                    auth.signOut().then(() => {
                      localStorage.clear();
                    });

                    window.setInterval(() => {
                      window.location.reload();
                    }, 2000);

                    this.$router.push({ name: "LoginPage" });
                  }
                } else {
                  // self.errorMessage = "User not valid";
                  // const auth = firebase.auth();
                  // auth.signOut().then(() => {
                  //   localStorage.clear();
                  //   this.$router.push({ name: "LoginPage" });
                  //   location.reload();
                  // });
                }
              });
            });
          // this.$router.push({ path: "/dashboard" });
        })
        .catch(function (error) {
          self.errorMessage = "Please Check Email and Password ";
          window.setInterval(() => {
            window.location.reload();
          }, 1000);
        });
      // } else {
      //   this.admin=true;
      // self.errorMessage = "Invalid user";
      // this.errors.clear();
      // this.$validator.reset();
      // this.$refs.pass.$el.focus();
      // }
    },
    sign() {
      this.$router.push({
        path: "/registerpage",
      });
    },
    forgotpassword() {
      this.$router.push({
        path: "/forgot",
      });
    },
    // submit() {
    //   let self = this;
    //   this.errMsg = null;
    //   this.err = null;
    //   const { dispatch } = self.$store;
    //   const data = {
    //     email: self.user.email,
    //     password: self.user.password,
    //   };
    //   APIService.login(data).then(
    //     (res) => {
    //       if (res.status == 200) {
    //         APIService.saveToken(res);
    //         self.$router.push({ name: "Dashboard" });

    //         // if (res.data.language && res.data.language == "Arabic") {
    //         //   self.$router.push({ name: "propertieslist_ar" });
    //         // } else {
    //         //   self.$router.push({ name: "property List3" });
    //         // }
    //       } else {
    //         self.errMsg = res.message;
    //         self.user.password = "";
    //         this.errors.clear();
    //         this.$validator.reset();
    //         this.$refs.pass.$el.focus();
    //         this.errMsg = "Please Check Email and Password ";
    //       }
    //     },
    //     (err) => {
    //       self.errMsg = "Something went wrong. Please try after sometime.";
    //     }
    //   );
    // },
  },
};
</script>
<style>
.register-now {
  margin-bottom: 5px;
  border-left-width: 1px;
  padding-left: 5px;
}

.buttonload {
  background-color: #04aa6d; /* Green background */
  border: none; /* Remove borders */
  color: white; /* White text */
  padding: 12px 24px; /* Some padding */
  font-size: 16px; /* Set a font-size */
}

/* Add a right margin to each icon */
.fa {
  margin-left: -12px;
  margin-right: 8px;
}
</style>
<style>
@import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css";
</style>